import { Box, Button, Center, Heading, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Logo } from "../../auth/components/shared/Logo";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  // SPA 404s respond with HTTP 200, so tell crawlers not to index this page
  useEffect(() => {
    document.title = "Page not found - Redwing";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);
    return () => {
      document.head.removeChild(robots);
    };
  }, []);

  return (
    <Box>
      <Center flexDirection="column">
        <Logo />
        <Heading>404 Page not found</Heading>
        <Text py="6">Sorry, the page you are looking for does not exist.</Text>
        <Button
          colorScheme="blue"
          color="white"
          onClick={() => navigate("/reading")}
        >
          Head back to my Reading
        </Button>
      </Center>
    </Box>
  );
}
